import { buildBaseEventData } from './commonAnalytics';
import { Utils } from './sendAnalyticsEvent';
import { getConfig } from '../../config';

const mapFulfillmentMethodToAnalyticsMethod = (method) => {
  switch (method) {
  case 'ShipToStore':
    return 'boss';
  case 'BOPIS':
    return 'bopis';
  case 'DeliverFromStore':
    return 'bodfs';
  default:
    return 'sth';
  }
};

const itemToThdAnalyticsEvent = (items) => {
  if (getConfig()?.isConsoleDebug) {
    // eslint-disable-next-line no-console
    console.log('itemToThdAnalyticsEvent =>', JSON.stringify(items));
  }

  const addToCartLocationEvent = buildBaseEventData('stash', 'cart add location');
  addToCartLocationEvent.eventMode = 'stash';

  addToCartLocationEvent.stash = {
    pageType: 'pip',
    sharedSection: '',
    section: '',
    component: '',
    target: 'atc',
    item: items.map((item) => ({
      index: '',
      productID: item.itemId,
    })),
  };

  const addToCartEvent = buildBaseEventData('overlay', 'cart add');

  addToCartEvent.item = items.map((item) => ({
    productInfo: {
      sku: item.itemId,
    },
    quantity: item.quantity,
    price: {
      basePrice: item.unitPrice * item.quantity,
    },
    fulfillment: {
      method: mapFulfillmentMethodToAnalyticsMethod(item.fulfillmentMethod),
    },
  }));

  return [addToCartLocationEvent, addToCartEvent];
};

export const sendAddToCartEvent = (items) => {
  const addToCartEvent = itemToThdAnalyticsEvent(items);
  Utils.sendAnalyticsEvent(addToCartEvent[0])
    .then(Utils.sendAnalyticsEvent(addToCartEvent[1]));
};

export const addToCartAnalytics = (items) => {
  if (getConfig()?.isConsoleDebug) {
    // eslint-disable-next-line no-console
    console.log('addToCartAnalytics items', JSON.stringify(items));
  }
  sendAddToCartEvent(items);
};
